module.exports = __webpack_public_path__ + "static/media/12.a2fe9b09.jpeg";